module.exports = __webpack_public_path__ + "img/ex10.bfa24ee1.png";